/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';



const PatientActivityTable=({pageNumber,List,setConfirmationState,setTextAreaMsg})=>{

    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();

    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    return(
        <div>
            <div className='h-[calc(100vh-256px)] 2xl:h-[calc(100vh-246px)] overflow-auto scrollbar_purple pb-2.5' onScroll={()=>setSelectedIndex('')}>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th className="px-[9px] py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Username
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Timestamp
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[150px]"  >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Vital Type
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[140px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">New Start
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[180px]" >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">New Frequency
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[140px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">New Delay
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[180px]">
                                <span className="flex items-center text-sm font-normal text-[#000000]">New Threshold
                                </span>
                            </th>
                            
                            <th className="px-[9px] py-2 min-w-[140px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000] ">Old Start
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[180px]">
                                <span className="flex items-center text-sm font-normal text-[#000000]">Old Frequency
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[140px]">
                                <span className="flex items-center text-sm font-normal text-[#000000]">Old Delay
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[180px]">
                                <span className="flex items-center text-sm font-normal text-[#000000]">Old Threshold
                                </span>
                            </th>
                           
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item,index)=>(
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default PatientActivityTable